module.exports = __webpack_public_path__ + "static/media/tab-ipsum-icon.8b6d0473.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tab-ipsum-icon.svg
// module id = ./src/images/tab-ipsum-icon.svg
// module chunks = 0